<script setup lang="ts">
import { getMinerModels } from '@/services/core.service'
import type { IMinerModel } from '@/types/rc/miners'
import { ElMessage } from 'element-plus'
import type { OptionType } from 'element-plus/es/components/select-v2/src/select.types.mjs'
import { ref, watch } from 'vue'

const props = withDefaults(defineProps<{ placeholder?: string }>(), {
  placeholder: 'Miner Models',
})

const selectedValues = defineModel<IMinerModel[]>()

const filterLoading = ref(false)
const filterOptions = ref<OptionType[]>([])

const filterValues = async (query: string) => {
  try {
    filterLoading.value = true

    const minerModels = await getMinerModels()
    filterOptions.value = minerModels
      .filter((res: IMinerModel) => {
        return res.name.toLowerCase().includes(query.toLowerCase())
      })
      .map((res: IMinerModel) => {
        return {
          label: res.name,
          value: res,
        }
      })
  } catch {
    ElMessage.error('Failed to filter miner models')
    filterOptions.value = []
  } finally {
    filterLoading.value = false
  }
}

// Add a watch to check selectedValues changes
watch(selectedValues, () => {
  if (selectedValues.value) {
    filterOptions.value.push(
      ...selectedValues.value.map((res: IMinerModel) => {
        return {
          label: res.name,
          value: res,
        }
      })
    )
  }
})
</script>

<template>
  <el-select-v2
    v-model="selectedValues"
    style="width: 280px"
    :options="filterOptions"
    :loading="filterLoading"
    remote
    :remote-method="filterValues"
    filterable
    clearable
    multiple
    collapse-tags
    collapse-tags-tooltip
    :max-collapse-tags="1"
    value-key="name"
    :placeholder="props.placeholder"
    loading-text="Loading..."
  />
</template>
